<template>
    <div>
      <CRow>
        <CCol sm="12" md="12">
          <CCard accent-color="primary">
            <CCardHeader
              class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
            >
              Ver Préstamo aplicado Folio:{{folio}}
              <div>
                <router-link :to="{
                        name: 'EditPrestamoAplicado',
                        params: {
                          folio: folio,
                          config: config
                        }
                      }">
                  <CButton color="success" class="mr-1 btn-header">
                    <CIcon class="mr-1" name="cil-pencil" />Editar
                  </CButton>
                </router-link>
                <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                  <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                  <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
                </CButton>
                <BackButton :to="{ name: 'PrestamoAplicado', params: { config: config } }">
                  <CButton color="primary" class="mr-1 btn-header">
                    <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                  </CButton>
                </BackButton>
              </div>
            </CCardHeader>

            <CCardBody v-if="isLoading">
              <div class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow">
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                </div>
              </div>
            </CCardBody>

            <CCardBody v-else>
              <CCol sm="12" class="text-right">
                {{ this.item.author.correo }}
              </CCol>
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <label>Fecha:</label>
                  <CInput v-model="date" disabled type="date" />
                </CCol>
              </CRow>

              <CRow>
                <CCol>
                  <label>Trabajador:</label>
                  <CSelect
                    :value.sync="trabajador"
                    disabled
                    horizontal
                    :options="trabajadores"
                    placeholder="Seleciona un trabajador"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <label>Fecha de pago:</label>
                  <CInput v-model="fecha_pago" disabled type="date" />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <CInput
                    :value.sync="semanas"
                    :label="`Semanas: `"
                    disabled
                    placeholder="Semanas..."
                    type="number"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <label>Fecha Inicial:</label>
                  <CInput v-model="dateInitial" disabled type="date" />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <CInput
                    :value.sync="monto"
                    :label="`Monto: `"
                    placeholder="Monto..."
                    type="number"
                    disabled
                  />
                </CCol>
              </CRow>
              <!-- <CRow>
                <CCol sm="12" md="9" lg="9">
                  <label><b>Prorrogas:</b></label>
                  <ul>
                    <li v-if="prorrogas.length <= 0" > N / A </li>
                    <li v-for="(prorroga, index) in prorrogas" :key="index">{{ prorroga }}</li>
                  </ul>
                </CCol>
              </CRow> -->
              <CRow>
                <CCol>
                  <label>Comentarios:</label>
                  <CTextarea v-model="comentarios" disabled horizontal />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <KlayFileDD
                    :fetching="fetching"
                    v-model="medias"
                    :label="`Anexos: `"
                    @onFetch="onFetch"
                    @onErrorFetch="(err)=>{
                      fetching=false;
                      error=err
                      warningModal=true
                    }"
                    :fetchMethod="pushMedia"
                    :baseSrc="$store.getters.MediaGet"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                  <i class="fa fa-spinner fa-pulse"></i>
                </CButton>
                <CButton v-else @click="()=>{fetching=true}" class="px-4 mx-3 btn-lg" color="success">
                  <span>Actualizar</span>
                </CButton>
              </CRow>
              <CModal
                size="sm"
                title="Préstamo"
                :centered="true"
                color="warning"
                :show.sync="warningModal"
              >{{ error }}</CModal>
              <CModal
                size="sm"
                title="Préstamo"
                :centered="true"
                color="success"
                :show.sync="successModal"
                >Guardado con éxito.
                <template #footer>
                  <CButton @click="successModal = false"  color="success">Aceptar</CButton>
                </template>
              </CModal>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </template>

  <script>

  import moment from 'moment'
  export default {
    name: "VerPrestamoAplicado",

    components: {

    },

    data() {
      return {
        folio: this.$route.params.id,
        config: this.$route.params.config,
        semanas: 1,
        monto: 1,
        item: {},
        fecha_pago: null,
        date: null,
        dateInitial: null,
        multi: null,
        trabajador: null,
        trabajadores: [],
        trabajadoresAll: [],
        categoria: null,
        categorias: [],
        categoriasAll: [],
        actividad: null,
        actividades: [],
        actividadesAll: [],
        ubicacion: null,
        ubicaciones: [],
        ubicacionesAll: [],
        prorrogas : [],
        tiempo_extra: false,
        isFijo: false,
        comentarios: '',
        successModal: false,
        warningModal: false,
        error: "",
        isLoading: false,
        isLoadingPage: false,
        currentAlertCounter: 0,
        fetching: false,
        medias:[],
        loader: false,
      };
    },

    computed: {
      ubicacionRaiz() {
        return this.$store.state.rootLocation
          ? this.$store.state.rootLocation.value
          : "";
      }
    },

    created() {
      this.isLoading = true;
      this.$store;

      const ubi = [
        this.$store.dispatch("customDocumentoHTTP", {
          schema: "prestamos_aplicados",
          filter: {
            wherein: [
              {
                field: "payload->encabezado->ubicacion_raiz_id",
                value: [this.ubicacionRaiz]
              }
            ],
            where: [
              {
                field: "folio",
                value: this.folio,
                operator: "="
              }
            ]
          }
        }),
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`
              },
              {
                field: "payload->suspendido",
                operator: "=",
                value: false
              },
            ],
          }
        })
      ];

      Promise.all(ubi)
        .then(([item, trabajadores]) => {
          this.item = item.data[0];
          this.trabajadores = trabajadores.data.map(trabajador => {
            return { value: trabajador.id, label: trabajador.payload.nombre };
          });

          this.trabajadoresAll = trabajadores.data;
          this.trabajador = this.item.payload.encabezado.trabajador_id;
          this.semanas = this.item.payload.encabezado.semanas;
          this.monto = this.item.payload.encabezado.monto;
        //   this.prorrogas = this.item.payload.prorrogas.fechas;
          this.comentarios = this.item.payload.encabezado.comentarios;
          this.medias = this.item.payload.anexos;

          this.fecha_pago = moment(this.item.payload.encabezado.fecha_pago, 'YYYY-MM-DD').format('YYYY-MM-DD')
          this.date = moment(this.item.payload.encabezado.fechahora, 'YYYY-MM-DD').format('YYYY-MM-DD')
          this.dateInitial = moment(this.item.payload.encabezado.fecha_inicial, 'YYYY-MM-DD').format('YYYY-MM-DD')
        })
        .finally(() => (this.isLoading = false));
    },

    methods: {
      getReporte(){
        if(this.loader){
          return
        }
        this.loader = true
        this.$forceUpdate();
        const reportCall = {
          reporte: "formato_prestamos_aplicados",
          params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
          pdf : true
        };

        // console.log(reportCall);
        // call.push(reportCall);


          this.$store.dispatch("reportsPDFHttp", {
            ...reportCall
          }).then(res => {

            const blob = res;

            let a = document.createElement("a");
            a.style = "display: none";
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "Reporte de préstamos aplicados.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.loader = false
            this.$forceUpdate();
          });
      },
      async onFetch(medias){
        this.fetching=false
        const {folio,serie,schema,payload} = this.item
        const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
        body.payload.anexos = medias
        delete body.payload.encabezado._relaciones
        this.$store.dispatch("customDocumentoRemplazarHTTP",body)
          .then( ()=>{
            this.currentAlertCounter = 6;
              // console.log(res.data);
              // this.$router.push({ name: "Produccion" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.fetching=false
            return;
          })

          .finally(() => {
            this.fetching=false
            if (!this.warningModal) {
              this.successModal = true;
            }
          });

      },
      async pushMedia(files) {
        const arr = [];

        for (const v of files.map(async (m) => {
          // eslint-disable-next-line no-extra-boolean-cast
          // eslint-disable-next-line no-extra-boolean-cast
          if(!!m.media){
            return Promise.resolve({data:m,status:"success"})
          }
          const formData = new FormData();
          formData.append("media", m);
          const promise = await this.$store.dispatch("customImageHTTP", formData);

          return promise;
        })) {
          const media = await v;
          if (media.status === "success") {
            arr.push(media.data);
          }
        }
        return arr;
        /*
          const formData = new FormData()
          formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
          this.$store.dispatch('MEDIA_CARGAR', formData)
        */
      },
    }
  };
  </script>


  <style src="spinkit/spinkit.min.css"></style>

  <style scoped>
  .catalogo-text {
    font-size: 1.2rem !important;
  }
  .line {
    color: #321fdb; /* old IE */
    background-color: #321fdb; /* Modern Browsers */
  }
  @media (max-width: 420px) {
    .btn-header {
      padding-left: 8px;
      padding-right: 8px;
      font-size: 12px;
    }
    .padding-sm {
      padding-left: 10px;
      padding-right: 10px;
    }
    .text-sm {
      font-size: 11px !important;
    }
    .margin-sm {
      margin: 5px;
    }
  }
  </style>
